var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScribble3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 29,
    viewBox: "0 0 143 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.9587C26.5513 5.9844 53.1126 5.00057 78.933 3.68845C90.2113 3.11532 105.212 2.53574 116.9 2.28132C124.077 2.1251 132.504 1.68785 139.713 2.37513C144.237 2.80642 135.388 4.4157 135.259 4.43892C125.532 6.18511 115.417 7.64056 105.41 8.75414C88.2531 10.6633 36.6978 15.2467 53.2886 12.1313C65.0697 9.919 78.1096 9.56152 90.423 9.3639C93.4861 9.31474 109.768 9.39845 97.0006 10.771C84.9645 12.065 72.5041 12.4951 60.2826 12.7645C54.346 12.8953 50.0632 12.925 44.2549 12.8114C42.6017 12.779 40.9445 12.752 39.3008 12.6472C37.5162 12.5334 36.7705 12.322 39.0511 12.0375C42.8875 11.5588 83.1692 9.96318 82.5548 12.9052C82.2552 14.3398 74.4789 15.4823 72.9798 15.7664C71.3456 16.076 60.6751 18.0052 61.0319 18.0412C67.4013 18.6853 78.7178 17.9631 83.7205 20.5975C87.577 22.6284 73.4771 26.3749 71.6893 27",
    stroke: "black",
    strokeWidth: 3.92798,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribble3);
export default __webpack_public_path__ + "static/media/scribble3.ccc3b340bc62133643bb553c9cf0a723.svg";
export { ForwardRef as ReactComponent };